/* eslint-disable react/no-array-index-key */
// ActionButtons.jsx
import React from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";

const ActionButtons = ({ actions, status, onActionClick }) => {
  const isPending = status === "Pending";
  const badgeBg = isPending ? "#E7A0071A" : "#1D6D001A";
  const badgeColor = isPending ? "#E7A007" : "#1D6D00";

  return (
    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
      {actions.map((action, index) => {
        if (action === "Verified") {
          return (
            <div
              key={`verified-${index}`}
              style={{
                borderRadius: "30px",
                backgroundColor: badgeBg,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.2rem 0.5rem",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: badgeColor,
                  }}
                />
                <span style={{ color: badgeColor }}>{action}</span>
              </div>
            </div>
          );
        }

        return (
          <Button
            key={`action-${index}`}
            variant="contained"
            size="small"
            style={{
              textTransform: "none",
              backgroundColor: "#3f51b5",
              color: "#fff",
            }}
            onClick={() => onActionClick(action)}
          >
            {action}
          </Button>
        );
      })}
    </div>
  );
};

export default ActionButtons;

ActionButtons.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
};